import { Moment } from 'moment';
import React from 'react';
import { DayElement, DayBackground } from './shared.styles';

interface IDayProps {
  dateIndex: number;
  dateValue: Moment;
  selected?: boolean;
  hovered: boolean;
  disabled: boolean;
  onSelectDate: (date: Moment) => void;
  onHoverDate: (date: Moment) => void;
  isEndDay: boolean;
  totalDay: number;
  highlight: boolean;
}
const Day: React.FC<IDayProps> = ({
  dateIndex,
  dateValue,
  selected,
  hovered,
  disabled,
  onSelectDate,
  onHoverDate,
  isEndDay,
  totalDay,
  highlight,
}) => {
  function selectDate(e: any): void {
    e.stopPropagation();
    e.preventDefault();

    if (disabled) return;
    onSelectDate(dateValue);
  }

  function handleHoverDate(): void {
    if (disabled || !onHoverDate) return;
    onHoverDate(dateValue);
  }

  return (
    <DayElement
      className={isEndDay ? `end` : ''}
      selected={selected}
      hovered={hovered}
      highlight={highlight}
      disabled={disabled}
      onClick={selectDate}
      onMouseEnter={handleHoverDate}
      role="button"
      tabIndex={-1}
      data-day-index={dateIndex}
      data-date-value={dateValue}
    >
      {hovered &&
        !(isEndDay && dateIndex === totalDay) &&
        !(dateIndex === 1 && selected && !isEndDay) && (
          <DayBackground
            isFirstDay={dateIndex === 1}
            isLastDay={dateIndex === totalDay}
          />
        )}
      <div className="text-day">{dateIndex}</div>
    </DayElement>
  );
};

export default Day;
